import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { Check, ChevronDown } from 'lucide-react';
import { Difficulty } from '../types';

interface SkillFilterProps {
  selectedSkill: Difficulty | null;
  onSelectSkill: (skill: Difficulty | null) => void;
}

const skills: (Difficulty | 'All')[] = ['All', 'Beginner', 'Intermediate', 'Advanced'];

const SkillFilter: React.FC<SkillFilterProps> = ({ selectedSkill, onSelectSkill }) => {
  const displayValue = selectedSkill || 'All';

  return (
    <div className="w-full">
      <Listbox value={displayValue} onChange={(value) => onSelectSkill(value === 'All' ? null : value as Difficulty)}>
        <div className="relative">
          <Listbox.Button className="relative w-full bg-[#1e1e1e] border border-[#333333] rounded-lg py-2 pl-4 pr-10 text-left">
            <span className="block truncate text-gray-300">{displayValue} Difficulty</span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDown className="h-5 w-5 text-gray-500" aria-hidden="true" />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-1 w-full bg-[#1e1e1e] border border-[#333333] rounded-lg py-1 shadow-lg">
              {skills.map((skill) => (
                <Listbox.Option
                  key={skill}
                  value={skill}
                  className={({ active, selected }) =>
                    `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                      active ? 'bg-[#2a2a2a]' : ''
                    } ${selected ? 'text-white' : 'text-gray-300'}`
                  }
                >
                  {({ selected }) => (
                    <>
                      <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                        {skill}
                      </span>
                      {selected && (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-white">
                          <Check className="h-5 w-5" aria-hidden="true" />
                        </span>
                      )}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default SkillFilter;